/**
 * Equalize heights of titles and descriptions in service items
 * Groups items by row and sets equal heights within each row
 */
function equalizeServiceHeights() {
  const containers = document.querySelectorAll('.com-services-single__content');
  
  containers.forEach(container => {
    const items = Array.from(container.querySelectorAll('.com-services-single__item'));
    
    if (items.length === 0) return;
    
    // Reset heights first
    items.forEach(item => {
      const title = item.querySelector('.com-services-single__item__title');
      const description = item.querySelector('.com-services-single__item__description');
      
      if (title) title.style.height = 'auto';
      if (description) description.style.height = 'auto';
    });
    
    // Group items by row based on their offsetTop
    const rows = [];
    let currentRow = [];
    let lastTop = -1;
    
    items.forEach(item => {
      const top = item.offsetTop;
      
      if (top !== lastTop) {
        if (currentRow.length > 0) {
          rows.push(currentRow);
        }
        currentRow = [item];
        lastTop = top;
      } else {
        currentRow.push(item);
      }
    });
    
    if (currentRow.length > 0) {
      rows.push(currentRow);
    }
    
    // Equalize heights within each row
    rows.forEach(rowItems => {
      let maxTitleHeight = 0;
      let maxDescHeight = 0;
      
      // Find maximum heights
      rowItems.forEach(item => {
        const title = item.querySelector('.com-services-single__item__title');
        const description = item.querySelector('.com-services-single__item__description');
        
        if (title) {
          maxTitleHeight = Math.max(maxTitleHeight, title.offsetHeight);
        }
        if (description) {
          maxDescHeight = Math.max(maxDescHeight, description.offsetHeight);
        }
      });
      
      // Apply maximum heights
      rowItems.forEach(item => {
        const title = item.querySelector('.com-services-single__item__title');
        const description = item.querySelector('.com-services-single__item__description');
        
        if (title && maxTitleHeight > 0) {
          title.style.height = maxTitleHeight + 'px';
        }
        if (description && maxDescHeight > 0) {
          description.style.height = maxDescHeight + 'px';
        }
      });
    });
  });
}

// Run on DOM load
document.addEventListener('DOMContentLoaded', equalizeServiceHeights);

// Run on window resize (debounced)
let resizeTimer;
window.addEventListener('resize', function() {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(equalizeServiceHeights, 250);
});

// Run when fonts are loaded (fixes issues with web fonts)
if (document.fonts) {
  document.fonts.ready.then(equalizeServiceHeights);
}
